import React from 'react'
import { suppressResizeObserverLoopError } from 'utils/suppressResizeObserverLoopError'
import './sentry/index'

suppressResizeObserverLoopError()
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import './translation/index'
import { Provider } from 'react-redux'
import ErrorBoundary from 'components/ui-kit/ErrorBoundary/index'
import store from 'redux-thunk/store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Sentry.ErrorBoundary fallback={() => <></>}>
        <ErrorBoundary>
          <ToastContainer
            position='bottom-right'
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='colored'
            style={{ zIndex: 99999 }}
            // open
            // autoClose={false}
          />
          <App />
        </ErrorBoundary>
      </Sentry.ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

export default store
